module.exports = __webpack_public_path__ + "static/media/flower-daffodil.c7beabce.svg";